const Timing = {
	frame() {
		return new Promise(resolve => {
			requestAnimationFrame(() => resolve());
		});
	},

	delay(amount: number) {
		return new Promise(resolve => {
			setTimeout(() => resolve(), amount);
		});
	},

	finishAnimation(target: HTMLElement) {
		return new Promise(resolve => {
			target.addEventListener("transitionend", () => {
				resolve();
			});
		});
	}
};

export default Timing;